<template>
    
    <div>
        <header role="heading">
            <h1>{{ msg }}</h1>
            <messages></messages>
        </header>
        <div id="myillini-dashboard">
            <div id="myillini-student-dashboard">
                <div class="dashboard-body row">
                    <div class="schedule-col col-12 col-lg-4">
                        <studentCourses></studentCourses>
                    </div><!--/schedule-col-->
                    <div class="grades-col col-12 col-lg-4">
                        <studentGrades></studentGrades>
                        <dars></dars>
                    </div><!--/grades-col-->
                    <div class="finances-announcements-col col-12 col-lg-4">
                        <announcements></announcements>
                        <studentBalance></studentBalance>
                        
                    </div>
                </div><!--/dashboard-body row-->
            </div><!--/myillini-student-dashboard-->
        </div>
    </div>
</template>

<script>
    import messages from "../components/Message.vue"
    import announcements from "../components/Announcements.vue"
    import studentBalance from "../components/StudentBalance.vue"
    import dars from "../components/Dars.vue"
    import studentGrades from "../components/StudentGrades.vue"
    import studentCourses from "../components/StudentCourses.vue"

    export default {
        name: 'Home',
        props: {
            msg: String
        },
        components: {
            messages,
            announcements,
            studentBalance,
            dars,
            studentGrades,
            studentCourses
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      
    
</style>

